import { render } from "./EditPricingRule.vue?vue&type=template&id=3cf079f4&ts=true"
import script from "./EditPricingRule.vue?vue&type=script&lang=ts"
export * from "./EditPricingRule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__